var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66663C5.39935 1.66663 1.66602 5.39996 1.66602 9.99996C1.66602 14.6 5.39935 18.3333 9.99935 18.3333C14.5993 18.3333 18.3327 14.6 18.3327 9.99996C18.3327 5.39996 14.5993 1.66663 9.99935 1.66663ZM9.99935 13.75C7.92435 13.75 6.24935 12.075 6.24935 9.99996C6.24935 7.92496 7.92435 6.24996 9.99935 6.24996C12.0743 6.24996 13.7493 7.92496 13.7493 9.99996C13.7493 12.075 12.0743 13.75 9.99935 13.75ZM9.99935 9.16663C9.54102 9.16663 9.16602 9.54163 9.16602 9.99996C9.16602 10.4583 9.54102 10.8333 9.99935 10.8333C10.4577 10.8333 10.8327 10.4583 10.8327 9.99996C10.8327 9.54163 10.4577 9.16663 9.99935 9.16663Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasters);
export default __webpack_public_path__ + "static/media/masters.519ce6fa3b4fb3d4b030c340790d8c4f.svg";
export { ForwardRef as ReactComponent };